import ChangePasswordForm from '../components/auth/ChangePasswordForm';

const ChangePasswordPage: React.FC = () => {
  return <ChangePasswordForm />;
};

export default ChangePasswordPage; 